<template>
  <div class="content">
    <div>
      <top></top>
      <div class="crumbs">
        <div class="crumbsBox">
          <span @click="gotoHome(1)">{{ $t("project.MANA项目对接") }}</span>
          <i>></i>
          <span @click="gotoHome(2)">{{ $t("project.找项目") }}</span>
          <i>></i>
          <span>{{ details.title }}</span>
        </div>
      </div>
      <div class="projectDetail">
        <div class="detailBox">
          <div class="introduce">
            <p class="title">{{ details.title }}</p>
            <p class="time">
              {{ timeStamp(details.expiryDate) }} {{ $t("project.截止") }}
            </p>
            <!-- <div class="detail" v-if="timeEnd">
              <p class="text">【项目简介】{{details.projectDescribe}}</p>
              <p class="text">【交付时间】8月24日（下周一）</p>
              <p class="text">【发布渠道】facebook</p>
              <p class="text">【海报文案】客户提供</p>
              <p class="text">【执行形式】长图</p>
              <p class="text">【画面风格】在传统toB信息图风格基础上（扁平化、商业、科技感）更趣味性一点</p>
            </div>-->
            <div class="detail">
              <p class="text">{{ details.projectDescribe }}</p>
            </div>
          </div>
          <div class="address">
            <p class="answer">
              {{ $t("project.地点") }}：
              <span>{{ details.country }} {{ details.city }}</span>
            </p>
            <p class="answer">
              {{ $t("project.类型") }}：
              <span>{{ projectStatus(details) }}</span>
            </p>
            <!--<p class="answer">
              {{$t('project.服务成果')}}：
              <span>{{serviceStatus(details)}}</span>
            </p>
            <p class="answer">
              {{$t('project.最晚交付时间')}}：
              <span>{{timeStamp(details.lastDeliveryDate)}}</span>
            </p>-->
            <p class="answer">
              {{ $t("project.需求方类型") }}：
              <span>{{ details.demandType }}</span>
            </p>
            <p class="answer">
              {{ $t("project.项目预算") }}：
              <span class="price">{{ budgetStatus(details) }}</span>
            </p>
          </div>
          <div class="takeProject">
            <p class="button" v-if="timeEnd && details.status == 1">
              <span class="take" @click="takeProject">{{
                $t("project.接项目")
              }}</span>
              <el-popover placement="bottom" width="240">
                <share :config="config"></share>
                <span class="share" slot="reference">{{
                  $t("global.分享")
                }}</span>
              </el-popover>
            </p>
            <p class="button" v-else>
              <span class="take1">{{ $t("project.已结束") }}</span>
            </p>
          </div>
        </div>
      </div>
      <footer-down class="searchFooter"></footer-down>
    </div>
    <div class="popBox" v-if="isShowBox1">
      <div class="box1">
        <img
          class="cha"
          @click="hideBox1"
          src="https://image.manamana.net/close_btn@2x.png"
          alt
        />
        <p class="title1">{{ $t("project.您尚未成为MANA平台创作者") }}</p>
        <p class="title2">
          {{
            $t(
              "project.发布1部及以上原创作品，即可成为MANA平台创作者，才可以接项目哦～"
            )
          }}
        </p>
        <div class="button" @click="subVideo">{{ $t("project.去发布") }}</div>
      </div>
    </div>
    <div class="popBox" v-if="isShowBox2">
      <div class="box2">
        <div class="top">
          {{ $t("project.接项目") }}
          <img
            class="cha"
            @click="hideBox2"
            src="https://image.manamana.net/close_btn@2x.png"
            alt
          />
        </div>
        <div class="paddingBox">
          <p class="title1">
            {{
              $t(
                "project.请填写以下信息，我们将把您填写的信息通过系统自动发送邮件到需求方的邮箱。"
              )
            }}
            <span @click="isShowBox3 = true">{{
              $t("project.查看邮件示例")
            }}</span>
          </p>
          <p class="title2">
            {{
              $t(
                "project.以下默认为您在个人中心上填写的信息。修改后仅用于邮件发送，将不会同时修改您的个人资料。"
              )
            }}
          </p>
          <div class="location">
            <span class="label">
              <i>*</i>
              {{ $t("global.所在地") }}
            </span>
            <el-select
              v-model="country"
              @change="resetArea"
              filterable
              :placeholder="$t('project.请搜索或选择国家')"
            >
              <el-option
                :label="language === 'zh' ? item.zh : item.en"
                :value="item.id"
                v-for="(item, i) in countryOptions"
                :key="i"
              ></el-option>
            </el-select>
            <el-select
              v-model="area"
              filterable
              :placeholder="$t('global.请选择城市')"
            >
              <el-option
                :label="language === 'zh' ? item.zh : item.en"
                :value="item.id"
                v-for="(item, i) in cityOptions"
                :key="i"
              ></el-option>
            </el-select>
          </div>
          <div class="introduce clearfix">
            <span class="label">
              <i>*</i>
              {{ $t("project.团队介绍") }}
            </span>
            <el-input
              v-model="introduce"
              maxlength="2000"
              show-word-limit
              type="textarea"
              :placeholder="$t('project.请介绍一下您的团队或自己')"
            ></el-input>
          </div>
          <div class="case">
            <p class="caseTitle">
              <span class="lebal">
                <i>*</i>
                {{ $t("project.添加案例") }}
              </span>
              <span class="explain">{{
                $t("project.最多添加3个，上下拖拽可调整排序")
              }}</span>
            </p>
            <div class="selectVideo" v-if="worksList.length">
              <draggable
                v-model="worksList"
                chosenClass="chosen"
                forceFallback="true"
                group="people"
                animation="500"
              >
                <div
                  class="selectOne"
                  v-for="(item, i) in worksList"
                  :key="i"
                  :class="{ active: isActive == i }"
                  @mouseover="isActive = i"
                >
                  <div class="worksImgBox">
                    <img
                      class="worksImg"
                      v-if="isActive == i"
                      src="https://image.manamana.net/sorting_move_icon@2x.png"
                      alt
                    />
                  </div>
                  <span class="worksTile">{{ item.label }}</span>
                  <span
                    class="worksDetele"
                    v-if="isActive == i"
                    @click="deteleWorks(i)"
                    >{{ $t("project.删除") }}</span
                  >
                </div>
              </draggable>
            </div>
            <div class="select">
              <el-select
                v-model="videoName"
                @change="addWorksList"
                filterable
                :placeholder="$t('project.搜索已发布的作品')"
              >
                <el-option
                  :label="item.title"
                  :value="item.id"
                  v-for="(item, i) in videoList"
                  :key="i"
                ></el-option>
              </el-select>
              <span @click="subVideo">{{ $t("project.上传新作品") }} ></span>
            </div>
          </div>
          <div class="contact">
            <span class="label">
              <i>*</i>
              {{ $t("global.联系方式") }}
            </span>
            <div class="phone">
              <span class="label">
                <i>*</i>
                {{ $t("global.手机号") }}
              </span>
              <input
                type="text"
                v-model="phone"
                :placeholder="$t('global.请输入手机号')"
              />
            </div>
            <div class="email">
              <span class="label">
                <i>*</i>
                {{ $t("global.邮箱") }}
              </span>
              <input
                type="text"
                v-model="email"
                :placeholder="$t('project.请输入邮箱')"
              />
            </div>
            <div class="landline" v-if="language == 'zh'">
              <span class="label">{{ $t("global.座机号") }}</span>
              <input
                type="text"
                v-model="landline"
                :placeholder="$t('project.请输入公司座机号')"
              />
            </div>
            <div class="weChat" v-if="language == 'zh'">
              <span class="label">{{ $t("global.微信号") }}</span>
              <input
                type="text"
                v-model="weChat"
                :placeholder="$t('project.请输入微信号')"
              />
            </div>
          </div>
          <div class="button" @click="submit">{{ $t("global.提交") }}</div>
        </div>
      </div>
    </div>
    <div class="popBox popBox1" v-if="isShowBox3">
      <div class="box2">
        <div class="top">
          邮件示例
          <img
            class="cha"
            @click="hideBox3"
            src="https://image.manamana.net/close_btn@2x.png"
            alt
          />
        </div>
        <div class="paddingBox1">
          <p class="htmlText">您好，</p>
          <br />
          <p class="htmlText">
            创作者「MANA超自然碰撞会」在MANA上看到您发布的项目，对您的项目非常感兴趣并想跟您合作。
          </p>
          <br />
          <p class="htmlText">团队所在地：中国 上海</p>
          <p class="htmlText">
            团队介绍：MANA超自然碰撞会，系由MANA主办的系列线上/线下行业交流活动。
          </p>
          <br />
          <p class="htmlText">TA的作品案例：</p>
          <p class="htmlText">
            【视觉体验和对品牌的理解 | Michael
            Arone主题演讲视频】https://www.manamana.net/video/detail?id=111432
          </p>
          <p class="htmlText">
            【透过新媒体艺术与技术提升过品牌体验 |
            赖裖羱主题演讲视频】https://www.manamana.net/video/detail?id=111371
          </p>
          <br />
          <p class="htmlText">
            TA的MANA个人主页：https://www.manamana.net/peopleCenter/459762/home
          </p>
          <br />
          <p class="htmlText">TA的联系方式：</p>
          <p class="htmlText">邮箱：mana@manamana.net</p>
          <p class="htmlText">手机号：15555555555</p>
          <p class="htmlText">座机号码：021-55555555</p>
          <p class="htmlText">微信：artmana</p>
          <br />
          <p class="htmlText">感兴趣就尽快联系TA吧！</p>
          <br />
          <br />
          <br />
          <p class="htmlText">___________</p>
          <br />
          <p class="htmlText">以上邮件为MANA系统发出，请勿回复！</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import top from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";
import Share from "@/components/v2/Share";
import draggable from "vuedraggable";

export default {
  name: "projectDetails",
  data() {
    return {
      isActive: 0,
      userId: null,
      videoList: [],
      videoName: "",
      worksList: [],
      details: {},
      config: {},
      isShowBox1: false,
      isShowBox2: false,
      isShowBox3: false,
      countryOptions: [],
      cityOptions: [],
      country: null,
      area: null,
      introduce: "",
      phone: "",
      email: "",
      landline: "",
      weChat: "",
      userCase: "",
      timeEnd: true,
    };
  },
  components: {
    top,
    FooterDown,
    Share,
    draggable,
  },
  created() {
    this.bulletin();
    document.documentElement.style.overflowY = "";
    // if (this.$store.state.peopleMessage) {
    //   this.phone = this.$store.state.peopleMessage.phone;
    //   this.email = this.$store.state.peopleMessage.email;
    //   this.userId = this.$store.state.peopleMessage.userId;
    //   this.country = +this.$store.state.peopleMessage.country;
    //   this.area = +this.$store.state.peopleMessage.area;
    //   this.introduce =
    //     this.language == "zh"
    //       ? this.$store.state.peopleMessage.introduce
    //       : this.$store.state.peopleMessage.enIntroduce;
    // }
    // if (localStorage.getItem("takeItem")) {
    //   this.details = JSON.parse(localStorage.getItem("takeItem"));
    //   var timestamp = new Date().getTime();
    //   if (this.details.expiryDate < timestamp) {
    //     this.timeEnd = false;
    //   } else {
    //     this.timeEnd = true;
    //   }
    //   this.config = {
    //     share_url: location.href,
    //     title: this.details.title,
    //     desc: "MANA 全球新媒体艺术平台",
    //     pics: ["http://image.manamana.net/1547206259704_manalogo.jpg"],
    //   };
    // }
    // if (this.userId) {
    //   this.getCountry();
    //   this.getVideoList();
    // }
  },
  watch: {
    country(value) {
      if (value || value === 0) {
        this.getCity(value);
      }
    },
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  methods: {
    projectStatus(item) {
      let text = "";
      let status = item.projectType;
      if (status == "") {
        return this.$t("project.暂无");
      }
      for (let i = 0; i < status.length; i++) {
        if (!status[i].indexOf("1")) {
          text = text.concat(this.$t("project.全案服务"));
        }
        if (!status[i].indexOf("2")) {
          text = text.concat(this.$t("project.咨询顾问"));
        }
        if (!status[i].indexOf("3")) {
          text = text.concat(this.$t("project.策展策划"));
        }
        if (!status[i].indexOf("4")) {
          text = text.concat(this.$t("project.创意创作"));
        }
        if (!status[i].indexOf("5")) {
          text = text.concat(this.$t("project.软硬件及工程技术"));
        }
        if (!status[i].indexOf("6")) {
          text = text.concat(this.$t("project.项目运营"));
        }
        if (!status[i].indexOf("7")) {
          text = text.concat(item.customerProjectType);
        }
      }
      return text;
    },
    serviceStatus(item) {
      let text = "";
      let status = item.serviceAchievement;
      if (status == "") {
        return this.$t("project.暂无");
      }
      for (let i = 0; i < status.length; i++) {
        if (!status[i].indexOf("1")) {
          text = text.concat(this.$t("project.整体解决方案"));
        }
        if (!status[i].indexOf("2")) {
          text = text.concat(this.$t("project.资讯、策划"));
        }
        if (!status[i].indexOf("3")) {
          text = text.concat(this.$t("project.方案设计"));
        }
        if (!status[i].indexOf("4")) {
          text = text.concat(this.$t("project.项目执行"));
        }
        if (!status[i].indexOf("5")) {
          text = text.concat(item.customerServiceAchievement);
        }
      }
      return text;
    },
    budgetStatus(item) {
      let text = "";
      let status = item.budget;
      if (status == "") {
        return this.$t("project.暂无");
      }
      for (let i = 0; i < status.length; i++) {
        if (!status[i].indexOf("1")) {
          text = text.concat(this.$t("project.3万以下"));
        }
        if (!status[i].indexOf("2")) {
          text = text.concat(this.$t("project.3-10万"));
        }
        if (!status[i].indexOf("3")) {
          text = text.concat(this.$t("project.10-20万"));
        }
        if (!status[i].indexOf("4")) {
          text = text.concat(this.$t("project.20-50万"));
        }
        if (!status[i].indexOf("5")) {
          text = text.concat(this.$t("project.50-100万"));
        }
        if (!status[i].indexOf("6")) {
          text = text.concat(this.$t("project.100万以上"));
        }
        if (!status[i].indexOf("7")) {
          text = text.concat(item.customerBudget);
        }
      }
      return text;
    },
    bulletin() {
      this.$http
        .get("/api/project/detail/" + this.$route.params.id)
        .then((res) => {
          if (res.code === "OK") {
            this.details = res.data;
            var timestamp = new Date().getTime();
            if (this.details.expiryDate < timestamp) {
              this.timeEnd = false;
            } else {
              this.timeEnd = true;
            }
            this.config = {
              share_url: location.href,
              title: this.details.title,
              desc: "MANA 全球新媒体艺术平台",
              pics: ["http://image.manamana.net/1547206259704_manalogo.jpg"],
            };
          }
        });
    },
    gotoHome(type) {
      if (type == 1) {
        this.$router.push("/project");
      }
      if (type == 2) {
        this.$router.push("/takeProject");
      }
    },
    subVideo() {
      // this.$router.push("/UpVideo");
      let routeData = this.$router.resolve({ path: "/UpVideo" });
      window.open(routeData.href, "_blank");
    },
    getVideoList() {
      const url = `/api/mobile/u/getVideoList`;
      const params = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 1000,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.videoList = res.data.list;
        }
      });
    },
    addWorksList(value) {
      const hasCreater = this.worksList.filter((item) => item.id == value);
      if (hasCreater.length) {
        this.$message.error(this.$t("project.该作品已添加"));
        return;
      }
      if (this.worksList.length && this.worksList.length >= 3) {
        this.$message.error(this.$t("project.最多添加3个"));
        return;
      }
      let title = "";
      for (let i = 0; i < this.videoList.length; i++) {
        if (this.videoList[i].id == value) {
          title = this.videoList[i].title;
        }
      }
      this.worksList.push({ id: value, label: title });
    },
    deteleWorks(index) {
      this.worksList.splice(index, 1);
    },
    hideBox1() {
      this.isShowBox1 = false;
      document.documentElement.style.overflowY = "";
    },
    hideBox2() {
      this.isShowBox2 = false;
      document.documentElement.style.overflowY = "";
    },
    hideBox3() {
      this.isShowBox3 = false;
      // document.documentElement.style.overflowY = "";
    },
    resetArea() {
      this.area = "";
    },
    getCountry() {
      this.$http.get("/api/mobile/area/getCountry").then((res) => {
        if (res.code === "OK") {
          const data = res.data;
          Object.keys(data).map((item) => {
            this.countryOptions = [...this.countryOptions, ...data[item]];
          });
          if (this.language === "zh") {
            this.countryOptions.unshift({
              city: [],
              en: "China",
              id: 0,
              py: "People's Republic of China",
              pyf: "P",
              value: "",
              zh: "中国",
            });
          }
        }
      });
    },
    getCity(id) {
      this.$http
        .get(`/api/mobile/area/getCityByCountryId?countryId=${id}`)
        .then((res) => {
          if (res.code === "OK") {
            this.cityOptions = res.data;
          }
        });
    },
    takeProject() {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push(
          "/login?redirecturl=" +
            window.location.pathname +
            window.location.search
        );
        return;
      }
      if (this.$store.state.peopleMessage) {
        this.phone = this.$store.state.peopleMessage.phone;
        this.email = this.$store.state.peopleMessage.email;
        this.userId = this.$store.state.peopleMessage.userId;
        this.country = +this.$store.state.peopleMessage.country;
        this.area = +this.$store.state.peopleMessage.area;
        this.introduce =
          this.language == "zh"
            ? this.$store.state.peopleMessage.introduce
            : this.$store.state.peopleMessage.enIntroduce;
      }
      this.getCountry();
      const url = `/api/mobile/u/getVideoList`;
      const params = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 1000,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.videoList = res.data.list;
          if (this.videoList.length == 0) {
            this.isShowBox1 = true;
            document.documentElement.style.overflowY = "hidden";
            return;
          }
          this.isShowBox2 = true;
          document.documentElement.style.overflowY = "hidden";
        }
      });
    },
    submit() {
      let userCaseList = [];
      let countryName = "";
      let areaName = "";
      if (this.worksList.length) {
        for (let i = 0; i < this.worksList.length; i++) {
          userCaseList.push(this.worksList[i].id);
        }
      }
      this.userCase = userCaseList.join();
      const reg1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      const reg2 = /^(1[3-9])\d{9}$/;
      if (this.country !== 0 && !this.country) {
        this.$message.error(this.$t("global.请选择国籍"));
        return;
      }
      if (this.area !== 0 && !this.area) {
        this.$message.error(this.$t("global.请选择城市"));
        return;
      }
      if (!this.introduce.replace(/[\r\n\s]/g, "")) {
        this.$message.error(this.$t("project.请填写简介"));
        return;
      }
      if (!this.userCase) {
        this.$message.error(this.$t("project.请添加案例"));
        return;
      }
      if (!reg2.test(this.phone)) {
        this.$message.error(this.$t("global.请输入正确的手机号"));
        return;
      }
      if (!reg1.test(this.email)) {
        this.$message.error(this.$t("project.请输入正确的邮箱"));
        return;
      }
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i].id === this.country) {
          countryName =
            this.language === "zh"
              ? this.countryOptions[i].zh
              : this.countryOptions[i].en;
        }
      }
      if (this.cityOptions && this.cityOptions.length && this.area) {
        for (let y = 0; y < this.cityOptions.length; y++) {
          if (this.cityOptions[y].id === this.area) {
            areaName =
              this.language === "zh"
                ? this.cityOptions[y].zh
                : this.cityOptions[y].en;
          }
        }
      }
      let form = {
        userId: this.userId,
        country: countryName,
        city: areaName,
        teamIntroduction: this.introduce,
        mobile: this.phone,
        email: this.email,
        telephone: this.landline,
        wechat: this.weChat,
        projectId: this.details.id,
        userCase: this.userCase,
      };
      this.$http.post("/api/project/create", form).then((res) => {
        if (res.code === "OK") {
          this.$message.success(res.message);
          this.isShowBox2 = false;
          document.documentElement.style.overflowY = "";
        }
      });
    },
  },
};
</script>
<style lang="stylus">
.introduce {
  .el-textarea {
    float: left;
    width: 540px;
    height: 104px;
    border: 1px solid rgba(224, 224, 224, 1);
    box-sizing: border-box;

    .el-textarea__inner {
      border: none;
      height: 94px;
      background: none;
    }
  }
}

.location {
  .el-select {
    margin-right: 12px;
  }

  .el-input__inner {
    border-radius: 0;
  }
}

.case {
  .el-input__inner {
    border-radius: 0;
  }

  .el-tree {
    margin: 13px 0;
    position: absolute;
    top: 22px;
    background: rgba(0, 0, 0, 0);
  }

  .el-tree-node {
    width: 500px;
    left: 0;
    height: 36px;
    background: rgba(0, 0, 0, 0);
    cursor: pointer;
  }

  .el-tree-node:hover {
    background: none;
  }

  .el-tree-node:focus {
    background: none;
  }

  .el-tree-node__content {
    height: 36px;
    line-height: 60px;
    display: inline-block;
    background: none;
    display: none;
  }

  .el-tree-node__expand-icon {
    background: none;
  }

  .el-tree-node__content:hover {
    background: none;
  }

  .el-tree-node__content:focus {
    background: none;
  }
}
</style>
<style lang="stylus" scoped>
.crumbs {
  width: 100%;
  height: 46px;
  background: #fff;

  .crumbsBox {
    width: 920px;
    height: 46px;
    line-height: 46px;
    margin: 0 auto;
    color: #E0E0E0;

    span {
      font-size: 12px;
      font-weight: 400;
      color: rgba(102, 112, 144, 1);
      cursor: pointer;
    }

    i {
      margin: 0 6px;
    }
  }
}

.projectDetail {
  width: 100%;
  background: #FAFAFA;
  padding: 40px 0 120px 0;

  .detailBox {
    width: 800px;
    margin: 0 auto;
    background: #fff;
    padding: 40px 60px 70px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);

    .introduce {
      padding-bottom: 32px;
      border-bottom: 1px dashed #EBEBEB;

      .title {
        width: 800px;
        min-height: 48px;
        font-size: 32px;
        font-weight: 600;
        color: rgba(10, 10, 10, 1);
        line-height: 48px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .time {
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin: 12px 0 24px 0;
      }

      .detail {
        p.text {
          width: 800px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 28px;
        }
      }
    }

    .address {
      padding-top: 24px;
      border-bottom: 1px dashed #EBEBEB;

      p {
        font-size: 16px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 24px;
        width: 800px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-word;

        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }

        span.price {
          font-size: 24px;
          font-weight: bold;
          color: rgba(252, 98, 64, 1);
        }
      }
    }

    .takeProject {
      margin-top: 50px;
      text-align: center;
      font-size: 0;

      .button {
        .take {
          display: inline-block;
          width: 140px;
          text-align: center;
          line-height: 40px;
          height: 40px;
          background: rgba(32, 38, 204, 1);
          font-size: 16px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          margin-right: 12px;
          cursor: pointer;
        }

        .take1 {
          display: inline-block;
          width: 140px;
          text-align: center;
          line-height: 40px;
          height: 40px;
          background: #CCCCCC;
          font-size: 16px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          margin-right: 12px;
          cursor: pointer;
        }

        .share {
          display: inline-block;
          width: 90px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border: 1px solid rgba(32, 38, 204, 1);
          font-size: 16px;
          font-weight: 600;
          color: rgba(32, 38, 204, 1);
          cursor: pointer;
          box-sizing: border-box;
        }
      }
    }
  }
}

.popBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1111;

  .box1 {
    width: 380px;
    background: rgba(255, 255, 255, 1);
    padding: 40px 30px 32px;
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .cha {
      width: 13px;
      height: 13px;
      position: absolute;
      right: 24px;
      top: 24px;
      cursor: pointer;
    }

    .title1 {
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }

    .title2 {
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      text-align: center;
      margin: 24px 0 28px;
    }

    .button {
      width: 140px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(32, 38, 204, 1);
      font-size: 16px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      margin: 0 auto;
      cursor: pointer;
    }
  }

  .box2 {
    width: 730px;
    height: 90vh;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    padding-bottom: 40px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .top {
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E0E0E0;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(10, 10, 10, 1);
      position: relative;

      .cha {
        width: 13px;
        height: 13px;
        position: absolute;
        right: 24px;
        top: 23px;
        cursor: pointer;
      }
    }

    .paddingBox {
      height: 87vh;
      overflow: scroll;
      padding: 0 30px;

      .title1 {
        font-size: 14px;
        font-weight: bold;
        margin: 19px 0 5px 0;
        color: 333;

        span {
          font-weight: normal;
          color: #2026CC;
          cursor: pointer;
        }
      }

      .title2 {
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }

      .label {
        display: inline-block;
        width: 108px;

        i {
          color: #FE5630;
        }

        font-size: 16px;
        font-weight: 500;
        color: #333;
      }

      .location {
        margin: 24px 0;
        font-size: 0;
      }

      .introduce {
        .label {
          float: left;
        }
      }

      .case {
        margin: 32px 0 24px 0;
        position: relative;

        .caseTitle {
          .lebal {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            display: inline-block;
            width: 108px;

            i {
              color: #FE5630;
            }
          }

          .explain {
            font-size: 13px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }

        .selectVideo {
          margin: 13px 0;

          .selectOne {
            width: 605px;
            height: 36px;
            line-height: 36px;
            margin-left: 75px;
            z-index: 11;
            cursor: pointer;

            .worksImgBox {
              display: inline-block;
              width: 11px;
              height: 18px;
              margin: 0 12px 0 10px;
            }

            .worksImg {
              width: 100%;
              height: 100%;
            }

            .worksTile {
              font-size: 14px;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
              display: inline-block;
              width: 500px;
            }

            .worksDetele {
              font-size: 14px;
              font-weight: 400;
              color: rgba(10, 10, 10, 1);
              cursor: pointer;
            }
          }

          .active {
            background: rgba(245, 245, 245, 0.4);
          }
        }

        .select {
          margin: 12px 0 0 108px;

          span {
            font-size: 14px;
            font-weight: 400;
            color: rgba(32, 38, 204, 1);
            margin-left: 20px;
            cursor: pointer;
          }
        }
      }

      .contact {
        .label {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          display: inline-block;
          width: 108px;

          i {
            color: #FE5630;
          }
        }

        .phone, .email {
          display: inline-block;
          width: 256px;

          .label {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            display: inline-block;
            width: 70px;
            text-align: right;

            i {
              color: #FE5630;
            }
          }

          input {
            display: inline-block;
            width: 174px;
            height: 40px;
            border: 1px solid rgba(224, 224, 224, 1);
            padding-left: 10px;
            box-sizing: border-box;
          }
        }

        .landline {
          display: inline-block;
          width: 256px;
          margin-left: 112px;
          margin-top: 16px;

          .label {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            display: inline-block;
            width: 70px;
            text-align: right;

            i {
              color: #FE5630;
            }
          }

          input {
            display: inline-block;
            width: 174px;
            height: 40px;
            border: 1px solid rgba(224, 224, 224, 1);
            padding-left: 10px;
            box-sizing: border-box;
          }
        }

        .weChat {
          display: inline-block;
          width: 256px;
          margin-top: 16px;

          .label {
            font-size: 16px;
            font-weight: 500;
            color: #333;
            display: inline-block;
            width: 70px;
            text-align: right;

            i {
              color: #FE5630;
            }
          }

          input {
            display: inline-block;
            width: 174px;
            height: 40px;
            border: 1px solid rgba(224, 224, 224, 1);
            padding-left: 10px;
            box-sizing: border-box;
          }
        }
      }

      .button {
        width: 144px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: rgba(32, 38, 204, 1);
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        margin: 40px auto 0;
        cursor: pointer;
      }
    }
  }
}

.popBox1 {
  z-index: 2222;
  background: none;

  .paddingBox1 {
    height: 82vh;
    overflow: scroll;
    padding: 20px 30px;

    .htmlText {
      line-height: 24px;
      font-size: 14px;
    }
  }
}

.searchFooter {
  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/project/projectDetails.vue